const PAGE_COUNT = 12;
const API_LOAD_COUNT = 4;
const LANDSCAPE_CARD_PREVIEW_LENGTH = 3;
const PORTRAIT_CARD_PREVIEW_LENGTH = 2;
const MOBILE_CARD_PREVIEW_LENGTH = 1;
const DESKTOP_CARD_PREVIEW_LENGTH = 4;
const OVERVIEW_PARAGRAPH_LENGTH = 10;
const VIEW_SERVICES_ACCORDION = 3;
const VIEW_FAQS_ACCORDION = 3;
const SUCCESS_STORIES_LENGTH = 4;
const LOAD_MORE_STORIES_LENGTH = 16;
const COMPANY_INFORMATION_ACCORDION = 4;
const DEFAULT_ACCORDION_SIZE = 3;
const FEATURED_SUCCESS_STORY_LENGTH = 3;
const NUMBERS = {
  SEVEN_HUNDRED_SIXTY_EIGHT: 768,
  ONE_THOUSAND_FORTY: 1040,
  ONE_THOUSAND_TWENTY_FOUR: 1024,
  SIX_HUNDRED_FOURTY: 640,
};
const DEFAULT_LANGUAGE = 'en-US';
const TRANSLATION_LANGUAGES = [{
  display: 'English',
  key: DEFAULT_LANGUAGE,
},
{
  display: 'Čeština',
  key: 'cs-CZ',
},
{
  display: 'Deutsch',
  key: 'de-DE',
},
{
  display: 'Français',
  key: 'fr-FR',
},
{
  display: 'Español',
  key: 'es-ES',
},
{
  display: 'Italiano',
  key: 'it-IT',
},
{
  display: 'Português',
  key: 'pt-BR',
},
{
  display: '繁體中文',
  key: 'zh-HK',
},
{
  display: '简体中文',
  key: 'zh-CN',
},
{
  display: '한국어',
  key: 'ko-KR',
},
{
  display: '日本語',
  key: 'ja-JP',
},
{
  display: 'English (Australia)',
  key: 'en-AU',
},
{
  display: 'Nederlands (Belgium)',
  key: 'nl-BE',
},
{
  display: 'Français (Belgium)',
  key: 'fr-BE',
},
{
  display: 'English (Canada)',
  key: 'en-CA',
},
{
  display: 'Français (Canada)',
  key: 'fr-CA',
},
{
  display: 'Dansk (Denmark)',
  key: 'da-DK',
},
{
  display: 'Deutsch (Germany)',
  key: 'de-DE',
},
{
  display: 'Español (Spain)',
  key: 'es-ES',
},
{
  display: 'English (Netherlands)',
  key: 'en-NL',
},
{
  display: 'Français (France)',
  key: 'fr-FR',
},
{
  display: 'English (Hong Kong)',
  key: 'en-HK',
},
{
  display: 'English (India)',
  key: 'en-IN',
},
{
  display: 'Español (Argentina)',
  key: 'es-AR',
},
{
  display: 'Magyar (Hungary)',
  key: 'hu-HU',
},
{
  display: 'English (Malaysia)',
  key: 'en-MY',
},
{
  display: 'Español (Mexico)',
  key: 'es-MX',
},
{
  display: 'English (United Arab Emirates)',
  key: 'en-AE',
},
{
  display: 'Nederlands (Netherlands)',
  key: 'nl-NL',
},
{
  display: 'English (New Zealand)',
  key: 'en-NZ',
},
{
  display: 'Norsk (Norway)',
  key: 'no-NO',
},
{
  display: 'Polski (Poland)',
  key: 'pl-PL',
},
{
  display: 'Português (Portugal)',
  key: 'pt-PT',
},
{
  display: 'English (Singapore)',
  key: 'en-SG',
},
{
  display: 'Suomi (Finland)',
  key: 'fi-FI',
},
{
  display: 'Svenska (Sweden)',
  key: 'sv-SE',
},
{
  display: 'Deutsch (Switzerland)',
  key: 'de-CH',
},
{
  display: 'English (South Africa)',
  key: 'en-ZA',
},
{
  display: 'Français (Switzerland)',
  key: 'fr-CH',
},
{
  display: 'Italiano (Switzerland)',
  key: 'it-CH',
},
{
  display: 'Türkçe (Turkey)',
  key: 'tr-TR',
},
{
  display: 'English (United Kingdom)',
  key: 'en-GB',
},
{
  display: '简体中文 (China)',
  key: 'zh-CN',
},
{
  display: '繁體中文 (Taiwan)',
  key: 'zh-TW',
}];
const PARTNERS_FILTER_TYPE = {
  offerings: 'offerings',
  Locations: 'locations',
  Languages: 'languages',
  Solutions: 'solutions',
  Services: 'services',
  Specializations: 'specializations',
  Affiliations: 'affiliations',
};
module.exports = {
  PAGE_COUNT,
  API_LOAD_COUNT,
  COMPANY_INFORMATION_ACCORDION,
  DEFAULT_ACCORDION_SIZE,
  LANDSCAPE_CARD_PREVIEW_LENGTH,
  PORTRAIT_CARD_PREVIEW_LENGTH,
  MOBILE_CARD_PREVIEW_LENGTH,
  DESKTOP_CARD_PREVIEW_LENGTH,
  OVERVIEW_PARAGRAPH_LENGTH,
  VIEW_SERVICES_ACCORDION,
  LOAD_MORE_STORIES_LENGTH,
  SUCCESS_STORIES_LENGTH,
  NUMBERS,
  FEATURED_SUCCESS_STORY_LENGTH,
  TRANSLATION_LANGUAGES,
  DEFAULT_LANGUAGE,
  PARTNERS_FILTER_TYPE,
  VIEW_FAQS_ACCORDION,
};
